export const UnlinkIcon = ({ stroke = "#000" }: { stroke?: string }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			data-testid="UnlinkIcon"
		>
			<path
				d="M12.0427 7.74166L13.0173 6.77266H13.006C13.5277 6.23208 13.8135 5.50657 13.8008 4.75543C13.788 4.00428 13.4777 3.28889 12.938 2.76633C12.4093 2.25644 11.7034 1.97151 10.9688 1.97151C10.2343 1.97151 9.5284 2.25644 8.99967 2.76633L8.025 3.73533M4.2963 7.45833L3.3273 8.42733C2.80561 8.96791 2.51976 9.69342 2.53251 10.4446C2.54526 11.1957 2.85556 11.9111 3.3953 12.4337C3.92403 12.9436 4.62993 13.2285 5.36447 13.2285C6.099 13.2285 6.8049 12.9436 7.33363 12.4337L8.30263 11.4647M5.9 1.93333V3.63333M2.5 5.33333H4.2M10.4333 11.5667V13.2667M12.1333 9.86666H13.8333"
				stroke={stroke}
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
